import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/api/registration.service';
import { MyRegiGoals, MyRegistrationStatsResponse } from 'src/app/api/types/registration';
import { LocalAuthService } from 'src/app/auth/local-auth.service';
import { DataPadService } from 'src/app/ui/data-pad/data-pad.service';
import { IconService } from 'src/app/ui/icon.service';
import { UiModule } from 'src/app/ui/ui.module';

interface RegistrationStats {
  totalOriginal: number;
  teamCount: number;
}

@Component({
  selector: 'app-my-registration-stats',
  templateUrl: './my-registration-stats.component.html',
  styleUrls: ['./my-registration-stats.component.scss'],
  standalone: true,
  imports: [CommonModule, UiModule]
})
export class MyRegistrationStatsComponent implements OnInit {
  weekStats: RegistrationStats = { totalOriginal: 0, teamCount: 0 };
  monthStats: RegistrationStats = { totalOriginal: 0, teamCount: 0 };
  yearStats: RegistrationStats = { totalOriginal: 0, teamCount: 0 };
  
  goals: MyRegiGoals = { week: 0, month: 0, year: 0 };
  
  weekPercentage: number = 0;
  monthPercentage: number = 0;
  yearPercentage: number = 0;
  
  currentYear: number = new Date().getFullYear();
  currentMonth: string = new Date().toLocaleString('default', { month: 'long' });

  constructor(
    private registrationService: RegistrationService,
    private authService: LocalAuthService,
    private dataPadService: DataPadService,
    public icons: IconService
  ) {}

  ngOnInit(): void {
    const staffId = this.authService.currentUser?.newstaffId;
    
    if (staffId) {
      this.registrationService.getMyRegistrationStats(staffId).subscribe(response => {
        // Always normalize goals to 0 if missing/null
        this.goals = {
          week: response.myRegiGoals.week ?? 0,
          month: response.myRegiGoals.month ?? 0,
          year: response.myRegiGoals.year ?? 0
        };

        // Week stats
        this.weekStats = {
          totalOriginal: response.weeklyStats.totalOriginal ?? 0,
          teamCount: response.weeklyStats.teamCount ?? 0
        };
        this.weekPercentage = this.calculatePercentage(
          this.weekStats.totalOriginal,
          this.goals.week ?? 0
        );

        // Month stats
        this.monthStats = {
          totalOriginal: response.monthlyStats.totalOriginal ?? 0,
          teamCount: response.monthlyStats.teamCount ?? 0
        };
        this.monthPercentage = this.calculatePercentage(
          this.monthStats.totalOriginal,
          this.goals.month ?? 0
        );

        // Year stats
        this.yearStats = {
          totalOriginal: response.yearlyStats.totalOriginal ?? 0,
          teamCount: response.yearlyStats.teamCount ?? 0
        };
        const yearlyGoal = (response.recGoals ?? this.goals.year ?? 0);
        this.goals.year = yearlyGoal;
        this.yearPercentage = this.calculatePercentage(
          this.yearStats.totalOriginal,
          yearlyGoal ?? 0
        );
      });
    }
  }

  private calculatePercentage(value: number, goal: number): number {
    if (goal > 0 && value > 0) {
      return Math.round((value / goal) * 100);
    }
    return 0;
  }

  updateMyRegistrationGoals() {
    this.dataPadService.showPanel({
      panelName: 'updateMyRegiGoals',
      inputData: {}
    });
  }
} 